import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// initial state
const state: workflow.state.WorkflowState = {
  workflows: {
    lists: null,
    modalStatus: true,
    current: null,
    drafterInfo: null,
    workflowMenuList: null,
    workflowHeader: null,
    documentPages: [],
  },
  options: {
    system: {},
    application: {},
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
